import {focusCycle} from '../../../utility/js/utils';

(function () {
    const $section = $('.figure-viewer');
    const $window = $(window);
    const $html = $('html');
    const $document = $(document);
    const $body = $('body');
    let $isHighRes = false;
    let isExpanded = false;
    const figureViewer = {
        options: {
            /*
             * false|classCombination|className|dataRel
             * */
            filter: false,
            filterClass: 'article__tabFigure',
        },
        $topRegHeight: $('.figure-viewer__reg__top').innerHeight(),
        vPort: 'screen-md',
        $figures: null,
        $figuresToShow: null,
        $figureWidth: null,
        $currentIndex: null,
        $focusedElementBeforeOpened: null,
        $section: $section,
        $holder: $section.find('.figure-viewer__hold__fig'),
        $holderElement: $section.find('.figure-viewer__hold__fig').find('figure'),
        $captionHolder: $section.find('.figure-viewer__hold__figcap'),
        $lister: $section.find('.figure-viewer__hold__list'),
        $figureRegionContainer: $section.find('.figure-viewer__reg__center'),
        $captionRegion: $section.find('.figure-viewer__cent__right'),
        $contentRegion: $section.find('.figure-viewer__cent__left'),
        $figureNav: $section.find('.figure-viewer__ctrl__next, .figure-viewer__ctrl__prev'),
        $zoominbtn: $section.find('.zoom-in'),
        $zoomoutbtn: $section.find('.zoom-out'),
        $zoomrange: $section.find('.zoom-range'),
        $zoomreset: $section.find('.reset'),
        $image: $section.find('figure'),
        $browsebtn: $('.figure-viewer__ctrl__browse'),
        $returnbtn: $('.figure-viewer__ctrl__return'),
        isMobile: false,
        islocked: false,
        offsetY: window.pageYOffset,
        $hideList: $('.zoomSlider, .figure-viewer__label__zoom'),
        $browseContainer: $('.figure-viewer__hold__list'),
        $captionTitle: $('.figure-viewer__title__text'),
        onHighRes: function () {
            import('./high-res-images').then(() => {
                figureViewer.onHighResCallback();
            });
        },
        expand: function () {
            // preserve backward compatibility with previous buggy version - it can be removed if filterContexts would become default behavior
            if (figureViewer.options.filter) {
                figureViewer.$figures = $document.find(
                    ':not(.figure-viewer__hold__list) > figure:not(.holder), :not(.figure-viewer__hold__list) > .figure:not(.holder)'
                );
            } else {
                figureViewer.$figures = $document.find('figure:not(.holder), .figure:not(.holder)');
            }

            figureViewer.$figures.each(function (index) {
                let $this = $(this);
                $this.data('index', index);
                if (figureViewer.options.filter) {
                    $this.addClass('figure'); // add class to be sure, that correct grid styling will be there
                    if (figureViewer.options.filter === 'dataRel') {
                        // move data-rel to container from child
                        let dataRelElement = $this.find('[data-rel]');
                        if (dataRelElement.length > 0 && dataRelElement.data().rel) {
                            $this.attr('data-rel', dataRelElement.data().rel);
                        }
                    }
                }
            });

            figureViewer.$figuresToShow = figureViewer.$figures;
        },
        /*
         * Filter grid view and navigation based on item opened and option provided by figureViewer.options.filter
         * */
        filter: function ($this) {
            if (figureViewer.options.filter === 'classCombination') {
                let className = $this.attr('class');
                figureViewer.$figuresToShow = figureViewer.$figures.filter('[class="' + className + '"]');
            } else if (figureViewer.options.filter === 'className') {
                figureViewer.$figuresToShow = figureViewer.$figures.filter('.' + figureViewer.options.filterClass);
            } else if (figureViewer.options.filter === 'dataRel') {
                let dataRel = $this.data('rel');
                if (dataRel) {
                    figureViewer.$figuresToShow = figureViewer.$figures.filter('[data-rel="' + dataRel + '"]');
                } else {
                    figureViewer.$figuresToShow = figureViewer.$figures;
                }
            } else {
                figureViewer.$figuresToShow = figureViewer.$figures;
            }

            figureViewer.$currentIndex = figureViewer.$figuresToShow.index($this);
        },
        control: function () {
            $(document).on(figureViewer.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                figureViewer.isMobile = true;
            });

            $(document).on(figureViewer.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                figureViewer.isMobile = false;
            });

            figureViewer.clickHandler();

            let $figureViewer = $body.find('.figure-viewer'),
                $controllerElement = $figureViewer.find('a, button');

            $controllerElement.each(function () {
                let $this = $(this);
                $this.on({
                    click: function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        if ($this.hasClass('figure-viewer__ctrl__close')) {
                            // close button
                            figureViewer.on.hide();
                        } else if ($this.hasClass('figure-viewer__ctrl__next')) {
                            // Next button
                            figureViewer.next();
                        } else if ($this.hasClass('figure-viewer__ctrl__prev')) {
                            // Prev Button
                            figureViewer.prev();
                        } else if ($this.hasClass('figure-viewer__ctrl__caption')) {
                            // open / close caption Button
                            figureViewer.captionToggle($this);
                        } else if ($this.hasClass('figure-viewer__ctrl__browse')) {
                            // browse all figures
                            isExpanded = false;
                            figureViewer.browse($(this));
                        } else if ($this.hasClass('figure-viewer__ctrl__return')) {
                            // browse all figures
                            figureViewer.return($(this));
                        }
                    },
                });
            });

            // preserve backward compatibility with previous buggy version - it can be removed if filterContexts would become default behavior
            if (figureViewer.options.filter) {
                $('.figure a:not(.open-figure-link)')
                    .not(':has(img)')
                    .click(function (e) {
                        let $img = $(this).find('img'),
                            shouldDefault = $(this).hasClass('linkBehavior');
                        if (!shouldDefault || $img.length !== 0) {
                            e.preventDefault();
                            $img.trigger('click');
                        }
                    });

                $('.figure a:not(.open-figure-link) img').click(function (e) {
                    e.stopPropagation();
                });
            } else {
                $(".figure a:not('.ppt-figure-link')")
                    .not(':has(img)')
                    .click(function (e) {
                        let $img = $(this).find('img'),
                            shouldDefault = $(this).hasClass('linkBehavior');
                        if (!shouldDefault || $img.length !== 0) {
                            //e.preventDefault();
                            $img.trigger('click');
                        }
                    });
            }

            $('body').keydown(function (event) {
                // is figureviewer open? no? than we don't do anything
                if ($body.attr('data-active') !== 'figureViewer') {
                    return;
                }

                if (event.keyCode === 37) {
                    // left
                    figureViewer.prev();
                } else if (event.keyCode === 39) {
                    // right
                    figureViewer.next();
                }
            });

            figureViewer.supplementary.control();

            figureViewer.hideOnClickOutside();

            figureViewer.resize();
            $(window).on('resized', function () {
                figureViewer.resize();
            });

            if (figureViewer.$figures.length === 1) {
                figureViewer.$figureNav.hide();
            }

            focusCycle(figureViewer.$section[0]);
        },
        hideOnClickOutside: function () {
            figureViewer.$image.on('click', function (e) {
                let isOutsideClick =
                    !$(e.target).closest('.figure__image').length &&
                    !$('.figure__image').is(e.target) &&
                    !$('.shortcutsViewHelpTxt').is(e.target) &&
                    !$(e.target).closest('.shortcutsViewHelpTxt').length &&
                    !$('.figure__highResImgReplacer').is(e.target) &&
                    !$(e.target).closest('.figure__highResImgReplacer').length;
                if (isOutsideClick) {
                    figureViewer.on.hide();
                }
            });
        },
        clickHandler: function () {
            $(document).on('click', '.figure__image, .open-figure-link', function (event) {
                event.preventDefault();
                const $self = $(this);
                if (
                    $self.parent().hasClass('figure-viewer__thumbnail-item') ||
                    $self.is('.figure__audio') ||
                    $self.is('.figure__video')
                ) {
                    return;
                }
                let $this = $self.closest('figure, .figure, .imageTable');
                if (!$this.hasClass('ui-disabled') && !$this.closest('.figure-viewer__hold__fig').length) {
                    // check if explicitly disabled or the figure is already in the viewer so the event is useless at this state. It also gets in the way of drag and drop functionality in the figure viewer.
                    figureViewer.on.show($this, $this.data('index'));
                }

                //fixing LIT-388506

                !$isHighRes && $('.shortcutsViewHelpTxt').length >= 0
                    ? $(document).find('.figure-viewer__cent__left .shortcutsViewHelpTxt').remove()
                    : UX.highResImg.shortcutsView($this);
            });
        },
        captionToggle: function ($elem) {
            figureViewer.toggle($elem.closest('.figure-viewer__cent__right'));
            figureViewer.toggle($('.figure-viewer__cent__left'));
            $elem.toggleClass('js-open');
            if (figureViewer.$holder.find('.figure__highResImgReplacer').length === 1 && $elem.hasClass('js-open')) {
                figureViewer.$holder.find('.figure__highResImgReplacer').css({width: '97%'});
            } else {
                figureViewer.$holder.find('.figure__highResImgReplacer').css({width: '100%'});
            }

            const captionBtn = document.querySelector('.figure-viewer__ctrl__caption');
            const holdCaption = document.querySelector('.figure-viewer__hold__figcap');
            const captionTitle = document.querySelector('.figure-viewer__title__text');

            isExpanded = !isExpanded;
            captionBtn.setAttribute('aria-expanded', isExpanded);
            holdCaption.classList.toggle('hidden', !isExpanded);
            captionTitle.classList.toggle('hidden', !isExpanded);
            UX.utils.focusCycleInitiator($section[0]);
            figureViewer.updateAriaLabelForCaptionHolder();
        },
        next: function () {
            // fixing LIT-390230 and LIT-390335
            // preserve backward compatibility with previous buggy version - it can be removed if filterContexts would become default behavior
            if (!figureViewer.options.filter) {
                figureViewer.$figuresToShow = figureViewer.$figures;
            }
            if (figureViewer.$currentIndex < figureViewer.$figuresToShow.length - 1) {
                if (!figureViewer.$figuresToShow.eq(figureViewer.$currentIndex + 1).closest('.figure-viewer').length) {
                    figureViewer.$currentIndex++;
                    let $next = figureViewer.$figuresToShow.eq(figureViewer.$currentIndex);
                    figureViewer.replace($next);
                    // fixing LIT-390336
                    if ($isHighRes === false && $('.shortcutsViewHelpTxt').length > 0) {
                        $(document).find('.figure-viewer__cent__left .shortcutsViewHelpTxt').remove();
                    }
                    $isHighRes && UX.highResImg.shortcutsView($next);
                    figureViewer.zoom.reset();
                }
            } else {
                figureViewer.$currentIndex = 0;
                let $next = figureViewer.$figuresToShow.eq(figureViewer.$currentIndex);
                figureViewer.replace($next);

                // fixing LIT-390336
                if ($isHighRes === false && $('.shortcutsViewHelpTxt').length > 0) {
                    $(document).find('.figure-viewer__cent__left .shortcutsViewHelpTxt').remove();
                }
                $isHighRes && UX.highResImg.shortcutsView($next);
                figureViewer.zoom.reset();
            }
            figureViewer.updateAriaLabelForCaptionHolder();
        },
        prev: function () {
            // fixing LIT-390230 and LIT-390335

            // preserve backward compatibility with previous buggy version - it can be removed if filterContexts would become default behavior
            if (!figureViewer.options.filter) {
                figureViewer.$figuresToShow = figureViewer.$figures;
            }

            if (figureViewer.$currentIndex >= 1) {
                if (!figureViewer.$figuresToShow.eq(figureViewer.$currentIndex - 1).closest('.figure-viewer').length) {
                    figureViewer.$currentIndex--;
                    let $prev = figureViewer.$figuresToShow.eq(figureViewer.$currentIndex);
                    figureViewer.replace($prev);

                    // fixing LIT-390336
                    if ($isHighRes === false && $('.shortcutsViewHelpTxt').length > 0) {
                        $(document).find('.figure-viewer__cent__left .shortcutsViewHelpTxt').remove();
                    }
                    $isHighRes && UX.highResImg.shortcutsView($prev);
                    figureViewer.zoom.reset();
                }
            } else {
                figureViewer.$currentIndex = figureViewer.$figuresToShow.length - 1;
                let $prev = figureViewer.$figuresToShow.eq(figureViewer.$currentIndex);
                figureViewer.replace($prev);

                // fixing LIT-390336
                if ($isHighRes === false && $('.shortcutsViewHelpTxt').length > 0) {
                    $(document).find('.figure-viewer__cent__left .shortcutsViewHelpTxt').remove();
                }
                $isHighRes && UX.highResImg.shortcutsView($prev);
                figureViewer.zoom.reset();
            }
            figureViewer.updateAriaLabelForCaptionHolder();
        },
        replace: function (element) {
            let $figure;
            figureViewer.pauseOriginalStream(element);
            $isHighRes = element.find('.figure__image').length && element.find('.figure__highResImgReplacer').length;
            $isHighRes
                ? ($figure = element.find('.figure__highResImgReplacer').clone())
                : ($figure = element.find('.figure__image').clone());

            $figure.each(function () {
                let $this = $(this);
                if ($this.attr('data-lg-src')) {
                    $this.attr('src', $this.attr('data-lg-src'));
                } else if ($this.attr('data-src')) {
                    $this.attr('src', $this.attr('data-src'));
                } else {
                    let figureLink = element.children('a');
                    figureLink.attr('href', figureLink.find('.figure__image').attr('src'));
                }
            });
            // handle multiple images in one figure
            if ($figure.length > 1) {
                // return one to image viewer and create navigation
                $figure = figureViewer.supplementary.show(element, $figure);
            } else {
                figureViewer.supplementary.hide();
            }

            figureViewer.streamReset(figureViewer.$holder, element);
            if ($isHighRes) {
                UX.highResImg.show(figureViewer.$holder, element);
                figureViewer.$figureWidth = figureViewer.$holder.find('.figure__highResImgReplacer').width();
            }

            figureViewer.$holder.find('.figure__highResImgReplacer').remove();
            figureViewer.$holder.find('.figure__image').remove();
            figureViewer.$holder.find('figure').append($figure.get(0).outerHTML);
            figureViewer.$captionHolder.empty();
            figureViewer.showCaptionTitle(element);
            const $caption = figureViewer.additionalBehaviorOnShow(element);
            figureViewer.showCaption($caption);
            figureViewer.removeFigureTitle();
            figureViewer.$figureWidth = figureViewer.$holder.find('.figure__image').width();
            figureViewer.zoom.check();
            figureViewer.headerOptions(element);
            figureViewer.additionalReplace();
        },
        additionalReplace: function () {},
        supplementary: {
            nav: null,
            /**
             *
             * @param element
             * @param $figure
             * @public
             * @returns {jQuery} current image
             */
            show: function (element, $figure) {
                // get current index
                let index = this.check(element),
                    $thumbnails = $figure.clone(),
                    self = this;

                // create supplementary navigation
                if (!this.nav) {
                    this.nav = $('<ul class="figure-viewer__hold__supplementary-nav"></ul>');
                    this.nav.appendTo(figureViewer.$section);
                }
                // create navigation items
                this.nav.empty();
                $thumbnails.each(function (index) {
                    let $thumb = $(
                        '<li><a href="#" title="Go to figure image ' +
                            (index + 1) +
                            '. of current figure." class="figure-viewer__thumbnail-item"></a></li>'
                    );
                    $thumb.find('a').append(this);
                    $thumb.find('a').on('click', function (event) {
                        event.preventDefault();
                        self.toIndex(element, index);
                    });
                    // add to nav
                    self.nav.append($thumb);
                });
                // set initial active class
                this.nav.find('li').eq(index).addClass('active');

                // return current into view
                return $figure.eq(index);
            },
            /**
             *
             * @public
             */
            hide: function () {
                if (this.nav) {
                    this.nav.empty();
                }
            },
            save: function (element, index) {
                element.data('figure-viewer-display', index);
            },
            check: function (element) {
                return element.data('figure-viewer-display') || 0;
            },
            toIndex: function (element, index) {
                let $images = element.find('.figure__image');
                if ($images.length === 1) {
                    // don't do anything for one image
                    return;
                }
                // loop on edges
                if (index >= $images.length) {
                    index = 0;
                }
                if (index < 0) {
                    index = $images.length - 1;
                }
                // append index image
                figureViewer.$holder.find('.figure__image').remove();
                figureViewer.$holder.find('.figure__highResImgReplacer').remove();

                const $image = $images.eq(index).clone();
                // get the correct size of the image if it's available
                if ($image.data('lg-src')) {
                    $image.attr('src', $image.data('lg-src'));
                }
                figureViewer.$holderElement.append($image);
                // toggle active class
                this.nav.find('li').removeClass('active');
                this.nav.find('li').eq(index).addClass('active');
                // save state
                this.save(element, index);
            },
            next: function (element) {
                let index = this.check(element) + 1;
                this.toIndex(element, index);
            },
            prev: function (element) {
                let index = this.check(element) - 1;
                this.toIndex(element, index);
            },
            /**
             *
             * @public
             */
            control: function () {
                $('body').on('keydown keyup', function (event) {
                    // is figureviewer open? no? than we don't do anything
                    if ($body.attr('data-active') !== 'figureViewer') {
                        return;
                    }

                    // fixing LIT-390230 and LIT-390335
                    // preserve backward compatibility with previous buggy version - it can be removed if filterContexts would become default behavior
                    if (!figureViewer.options.filter) {
                        figureViewer.$figuresToShow = figureViewer.$figures;
                    }

                    // is there any figure to show?
                    if (figureViewer.$figuresToShow && figureViewer.$figuresToShow.length < 1) {
                        return;
                    }

                    let element = figureViewer.$figuresToShow.eq(figureViewer.$currentIndex);

                    if (event.keyCode === 38) {
                        // up
                        figureViewer.supplementary.prev(element);
                    } else if (event.keyCode === 40) {
                        // down
                        figureViewer.supplementary.next(element);
                    }
                });
            },
        },
        browse: function (element) {
            figureViewer.$holder.addClass('is-hidden');
            figureViewer.$figureNav.addClass('is-hidden');
            figureViewer.$browsebtn.addClass('is-hidden');
            figureViewer.$returnbtn.removeClass('is-hidden');
            figureViewer.$captionRegion.removeClass('js-open');
            figureViewer.$contentRegion.removeClass('js-open');
            figureViewer.$figureRegionContainer.addClass('scrollable');
            figureViewer.$captionRegion.addClass('is-hidden');
            figureViewer.$hideList.each(function () {
                $(this).addClass('is-hidden');
            });
            figureViewer.$lister.removeClass('is-hidden');
            figureViewer.supplementary.hide();

            figureViewer.$browseContainer.empty();
            // preserve backward compatibility with previous buggy version - it can be removed if filter would become default behavior
            if (figureViewer.options.filter) {
                figureViewer.$figuresToShow.each(function () {
                    let $fig = $(this).clone(true),
                        $figureExtra = $fig.find('.figure-extra');

                    if ($figureExtra.length) {
                        $figureExtra.remove();
                    }
                    figureViewer.$browseContainer.append($fig);
                });
            } else {
                figureViewer.$figures.each(function () {
                    if ($(this).hasClass('article__inlineFigure')) {
                        let $fig = $(this).clone(true);
                        const $figImage = $fig.children('img');
                        $figImage.attr('src', $figImage.data('src'));

                        let $figureLinks = $fig.find('.figure-links');

                        if ($figureLinks.length) {
                            $figureLinks.remove();
                        }
                        figureViewer.$browseContainer.append($fig);
                    }
                });
            }
            figureViewer.additionalBrowse();
        },
        additionalBrowse: function () {},
        return: function () {
            figureViewer.$holder.removeClass('is-hidden');
            figureViewer.$figureNav.removeClass('is-hidden');
            figureViewer.$browsebtn.removeClass('is-hidden');
            figureViewer.$returnbtn.addClass('is-hidden');
            //figureViewer.$contentRegion.addClass('js-open');
            figureViewer.$captionRegion.removeClass('is-hidden');
            figureViewer.$hideList.each(function () {
                $(this).removeClass('is-hidden');
            });
            figureViewer.$lister.addClass('is-hidden');
            const $figureViewText = $('.figure-viewer__title__text');
            $figureViewText.removeClass('figure-viewer__title__text__allfigures');
            $figureViewText.parent('.figure-viewer__ctrl').removeClass('allfigures__is__displayed');
            $('.figure-viewer__ctrl__caption').parent('.figure-viewer__ctrl').show();
            figureViewer.$browseContainer.empty();
            figureViewer.additionalReturn();
        },
        additionalReturn: function () {},
        height: function (element) {
            let $windowsHeight = $(window).innerHeight();
            figureViewer.$topRegHeight = $('.figure-viewer__reg__top').innerHeight();
            let $height =
                $windowsHeight - figureViewer.$topRegHeight - $('.figure-viewer__caption__label').innerHeight();
            $('.figure-viewer__cent__left').find('figure').height($height);
        },
        toggle: function (element) {
            element.toggleClass('js-open');
            figureViewer.figcaptionSize(); //LIT-161818
        },
        displayViewer: function () {
            $('.figure-viewer').show();
        },
        additionalShow: function () {},
        on: {
            show: function ($this, index) {
                figureViewer.isMobile && $html.addClass('lock-screen');
                figureViewer.headerOptions($this);

                figureViewer.offsetY = $body.data('yoffset') || window.pageYOffset;
                $body.data('yoffset', figureViewer.offsetY);
                if (typeof UX.controller !== 'undefined') {
                    if ($body.attr('data-active') !== 'slide') {
                        // keep drop block open in publication content widget
                        UX.controller.check();
                    }
                }
                $body.attr('data-active', 'figureViewer');
                figureViewer.islocked = true;
                figureViewer.$currentIndex = index;
                figureViewer.replace($this);
                figureViewer.$focusedElementBeforeOpened = document.activeElement;
                figureViewer.displayViewer();
                $body.css('overflow', 'hidden'); // LIT-152707
                figureViewer.height();
                figureViewer.zoom.check();
                figureViewer.resize();
                figureViewer.$holder.removeClass('is-hidden');
                if (figureViewer.$figuresToShow.length > 1) {
                    figureViewer.$browsebtn.removeClass('is-hidden');
                }
                figureViewer.$returnbtn.addClass('is-hidden');
                figureViewer.$figureNav.removeClass('is-hidden');
                figureViewer.$hideList.each(function () {
                    $(this).removeClass('is-hidden');
                });
                figureViewer.$lister.addClass('is-hidden');
                figureViewer.$figureRegionContainer.removeClass('scrollable');
                $('.figure-viewer__ctrl__close').focus();
                if (figureViewer.options.filter) {
                    figureViewer.filter($this);
                } else {
                    figureViewer.setFiguersToShow($this);
                }
                figureViewer.additionalShow();
                figureViewer.streamReset(figureViewer.$holder, $this.closest('figure'));
                $isHighRes && UX.highResImg.show(figureViewer.$holder, $this.closest('figure'));
                figureViewer.on.additionalOnShow();
            },
            hide: function () {
                figureViewer.isMobile && $html.hasClass('lock-screen') && $html.removeClass('lock-screen');
                if (figureViewer.islocked) {
                    $body.removeAttr('data-active');
                } else {
                    $body.removeClass('lock-screen').removeAttr('data-active');
                }
                figureViewer.zoom.reset();
                $('.figure-viewer').hide();
                figureViewer.pauseClonedStream(figureViewer.$holder);
                figureViewer.$focusedElementBeforeOpened.focus();
                $body.css('overflow', ''); // LIT-152707
                $(window).scrollTop(figureViewer.offsetY);
                $body.removeData('yoffset');
                figureViewer.on.additionalOnHide();
            },
            additionalOnShow: function () {},
            additionalOnHide: function () {},
        },
        setFiguersToShow($this) {
            if ($this.hasClass('article__tabFigure')) {
                figureViewer.$figuresToShow = figureViewer.$figures.filter('.article__tabFigure');
            } else if ($this.hasClass('article__inlineFigure')) {
                figureViewer.$figuresToShow = figureViewer.$figures.filter('.article__inlineFigure');
            } else {
                figureViewer.$figuresToShow = figureViewer.$figures;
            }
        },
        additionalBehaviorOnShow: function ($el) {
            return $el.find('figcaption, .figcaption').clone();
        },
        zoom: {
            /*init: function (element) {
             let figureViewer.$section = $('.figure-viewer');
             },*/
            reset: function () {
                const $elem = $('.figure-viewer').find('figure');
                $elem.panzoom('reset');
            },
            check: function () {
                figureViewer.zoom.panzoom.init();
                if ($window.width() < 992) {
                    figureViewer.zoom.swap();
                }
            },
            panzoom: {
                // zoom in functionality
                init: function () {
                    if (typeof $.fn.panzoom != 'undefined') {
                        figureViewer.$image.panzoom({
                            $zoomIn: figureViewer.$zoominbtn,
                            $zoomOut: figureViewer.$zoomoutbtn,
                            $zoomRange: figureViewer.$zoomrange,
                            $reset: figureViewer.$zoomreset,
                            panOnlyWhenZoomed: true,
                            minScale: 1,
                        });

                        figureViewer.$image.on('panzoomchange', function (e) {
                            if (figureViewer.$zoomrange.val() === '1') {
                                figureViewer.$image.css('transform', 'matrix(1, 0, 0, 1, 0, 0)');
                                $(this).removeClass('zoomed');
                            } else {
                                $(this).addClass('zoomed');
                            }
                        });
                    }
                },
            },
            swap: function () {
                // swap functionality for mobile devices
                figureViewer.$section.find('img').swipe({
                    //Generic swipe handler for all directions
                    swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                        if (direction === 'left' && !figureViewer.$section.find('figure').hasClass('zoomed')) {
                            figureViewer.next();
                        } else if (direction === 'right' && !figureViewer.$section.find('figure').hasClass('zoomed')) {
                            figureViewer.prev();
                        }
                    },
                });
            },
        },
        slide: function () {
            let $target = $body.find('div.ux3-in-slide');
            $body.removeAttr('data-ux3-show');
            setTimeout(function () {
                $target.append($slide.children('div')); /*eslint-disable-line*/
                $target.removeClass('ux3-in-slide');
            }, 250);
        },
        resize: function () {
            let wHeight = $window.innerHeight();
            const topHeight = figureViewer.$topRegHeight || 56;
            if (figureViewer.isMobile) {
                figureViewer.$figureRegionContainer.css('height', wHeight - topHeight);
            } else {
                figureViewer.$figureRegionContainer.css('height', `calc(100vh - ${topHeight}px)`);
            }
        },
        figcaptionSize: function () {
            let $figcaption = $('.figure-viewer__hold__figcap').find('figcaption'),
                figure_area_height = figureViewer.$figureRegionContainer.height(),
                figure_title_height = $('.figure-viewer__title').height() + 30,
                padding = 30;

            $figcaption.css('max-height', figure_area_height - 2 * padding - figure_title_height);
        },
        doubleTap: function () {
            // disable double tap zooming functionality on mobile devices
            (function ($) {
                $.fn.nodoubletapzoom = function () {
                    $(this).bind('touchstart', function preventZoom(e) {
                        let t2 = e.timeStamp,
                            t1 = $(this).data('lastTouch') || t2,
                            dt = t2 - t1,
                            fingers = e.originalEvent.touches.length;
                        $(this).data('lastTouch', t2);
                        if (!dt || dt > 500 || fingers > 1) {
                            return; // not double-tap
                        }
                        e.preventDefault(); // double tap - prevent the zoom
                        // also synthesize click events we just swallowed up
                        $(e.target).trigger('click');
                    });
                };
            })(jQuery);
        },
        init: function () {
            figureViewer.expand();
            figureViewer.control();
            figureViewer.doubleTap();
            $('body').nodoubletapzoom();
            $('.figure__highResImgReplacer').length && figureViewer.onHighRes();
        },
        showCaption: function ($caption) {
            if ($caption.length) {
                figureViewer.$captionHolder.append($caption);
                figureViewer.$captionHolder.find('figcaption').removeClass('hidden');
                figureViewer.$captionRegion.removeClass('is-hidden');
                // here we check if the caption region has the js-open or not to toggle the $contentRegion again
                // this behavior only happen when you toggle the caption holder then you click on a figure that does not
                // have a caption then again move to a figure with caption
                if (figureViewer.$captionRegion.hasClass('js-open')) {
                    figureViewer.$contentRegion.addClass('js-open');
                }
            } else if (!figureViewer.$captionHolder.hasClass('is-hidden')) {
                figureViewer.$captionRegion.addClass('is-hidden');
                figureViewer.$contentRegion.removeClass('js-open');
            }
        },
        showCaptionTitle: function ($element) {
            const $caption = $element.find('.figure__title, .captionLabel').clone();
            $('.figure-viewer__title__text').text($caption.text());
        },
        headerOptions: function ($this) {
            let $figureExtra = $this.find('.figure-extra'),
                figureExtraContent = $figureExtra.clone();

            $body.find('.figureExtra').length ? $body.find('.figureExtra').remove() : '';

            if (
                $this.find('.figure__image').is('.figure__audio') ||
                $this.find('.figure__image').is('.figure__video')
            ) {
                $body
                    .find('.figure-viewer__top__left')
                    .addClass('hidden')
                    .after('<div class="figure-viewer__top__left figureExtra">');
                $body.find('.figureExtra').append(figureExtraContent);
                figureExtraContent.appendTo($body.find('.figureExtra'));
                $body.find('.figureExtra').find('.open-figure-link').remove();
            } else if ($body.find('.figure-viewer__top__left').hasClass('hidden')) {
                $body.find('.figure-viewer__top__left').removeClass('hidden');
            }
        },
        streamReset: function ($holder, $originalFigure) {
            setTimeout(function () {
                if ($holder.find('stream').length) {
                    $holder.find('stream').html('');
                    $.getScript(UX.loader.cloudFlareScript);
                    $holder.find('stream').get(0).currentTime = $originalFigure.find('stream').get(0).currentTime;
                } else if ($holder.find('audio').length) {
                    $holder.find('audio').get(0).currentTime = $originalFigure.find('audio').get(0).currentTime;
                }
            }, 500);
        },
        pauseOriginalStream: function ($element) {
            if ($element.find('stream, audio').length) {
                $element.find('stream, audio').get(0).pause();
            }
        },
        pauseClonedStream: function ($holder) {
            if ($holder.find('stream, audio').length) {
                $holder.find('stream, audio').get(0).pause();
            }
        },
        removeFigureTitle: function () {
            figureViewer.$captionHolder.find('.figure__title').remove();
        },
        onHighResCallback: function () {},
        updateAriaLabelForCaptionHolder: function () {
            figureViewer.$captionHolder.attr('aria-label', `Caption for ${figureViewer.$captionTitle.text()}`);
        },
    };

    UX.figureViewer = figureViewer; // add to global namespace
})();
